// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1325":"444d57e3","2481":"dce58943","9013":"444d57e3","9349":"9557cee2"}[chunkId] + ".chunk.css";
};